module.exports = __webpack_public_path__ + "static/media/logo_black.c4c1b347.png";